module.exports = __webpack_public_path__ + "static/media/Stellar Ark King Headboard - 180 cm_Black.89b24af9.png";